var map = {
	"./4s.svg": 60934,
	"./avatar.svg": 43742,
	"./close-icon.svg": 37215,
	"./dashboard.svg": 76415,
	"./expand.svg": 74305,
	"./lambda.svg": 10396,
	"./logout.svg": 55607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19206;